import getWorship from "./getWorship"

export { getWorship }

const worship = {
	getWorship,
}

export default worship
